// src/components/StoreModal.jsx
import { X, Pickaxe, Shirt, ArrowRight, Crown } from "lucide-react";
import { OriginalModalShell } from "./ModalShell";

export default function StoreModal({ onClose, showToast, onOpenMcStore }) {
  const openMerchStore = () => {
    window.location.href = "https://store.theonesabove.com";
  };

  return (
    <OriginalModalShell onClose={onClose} maxWidth={720}>
      <style>{`
        @media(max-width:600px){
          .sm-header{padding:16px 16px 0!important}
          .sm-title-main{font-size:16px!important}
          .sm-title-sub{font-size:11px!important;margin-bottom:12px!important}
          .sm-grid{grid-template-columns:1fr!important;gap:10px!important;padding:12px 14px 18px!important}
          .sm-card{padding:18px 16px!important}
          .sm-card-icon{width:48px!important;height:48px!important;margin-bottom:12px!important}
          .sm-card-icon svg{width:24px!important;height:24px!important}
          .sm-card-title{font-size:15px!important;margin-bottom:6px!important}
          .sm-card-desc{font-size:11px!important;line-height:1.55!important;margin-bottom:12px!important}
          .sm-tags{margin-bottom:10px!important}
          .sm-tag{font-size:9px!important;padding:2px 7px!important}
          .sm-btns{margin-bottom:10px!important}
          .sm-cta{font-size:11px!important;padding:8px 16px!important}
        }
      `}</style>

      {/* Header */}
      <div
        className="sm-header"
        style={{
          padding: "24px 32px 0",
          position: "relative",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 16,
            right: 20,
            width: 28,
            height: 28,
            background: "rgba(255,255,255,.04)",
            border: "1px solid #2a2040",
            cursor: "pointer",
            color: "#4a4060",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: ".15s",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.borderColor = "#7b5ea7";
            e.currentTarget.style.color = "#c9a84c";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.borderColor = "#2a2040";
            e.currentTarget.style.color = "#4a4060";
          }}
        >
          <X style={{ width: 11, height: 11 }} />
        </button>

        <div style={{ textAlign: "center", marginBottom: 8 }}>
          <div
            style={{
              fontFamily: "'Cinzel Decorative',serif",
              fontSize: 13,
              color: "var(--gold,#c9a84c)",
              marginBottom: 4,
            }}
          >
            The Ones Above
          </div>

          <div
            className="sm-title-main"
            style={{
              fontFamily: "'Cinzel Decorative',serif",
              fontSize: 22,
              color: "#e2d9f3",
              marginBottom: 6,
            }}
          >
            The Store
          </div>

          <div
            className="sm-title-sub"
            style={{
              fontSize: 12,
              color: "#6b6080",
              fontFamily: "'Cinzel',serif",
              letterSpacing: 0.5,
            }}
          >
            Level up in-game or rep the creed in real life - choose your path.
          </div>
        </div>
      </div>

      {/* Store cards */}
      <div
        className="sm-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 20,
          padding: "20px 32px 28px",
        }}
      >
        {/* TOA Apparel */}
        <div
          className="sm-card"
          style={{
            padding: "32px 24px",
            textAlign: "center",
            cursor: "pointer",
            background: "linear-gradient(145deg,#1a0f00,#2c1900)",
            border: "1px solid rgba(201,168,76,.22)",
            position: "relative",
            overflow: "hidden",
            transition: ".25s",
          }}
          onClick={openMerchStore}
          onMouseOver={(e) => {
            e.currentTarget.style.borderColor =
              "rgba(201,168,76,.45)";
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow =
              "0 16px 50px rgba(201,168,76,.12)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.borderColor =
              "rgba(201,168,76,.22)";
            e.currentTarget.style.transform = "";
            e.currentTarget.style.boxShadow = "";
          }}
        >
          <div
            className="sm-card-icon"
            style={{
              width: 72,
              height: 72,
              borderRadius: 16,
              background:
                "linear-gradient(135deg,rgba(201,168,76,.2),rgba(201,168,76,.06))",
              border: "1px solid rgba(201,168,76,.28)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
              position: "relative",
              zIndex: 1,
            }}
          >
            <Shirt
              style={{
                width: 34,
                height: 34,
                color: "#c9a84c",
              }}
            />
          </div>

          <div
            className="sm-card-title"
            style={{
              fontFamily: "'Cinzel Decorative',serif",
              fontSize: 20,
              color: "#c9a84c",
              marginBottom: 10,
              position: "relative",
              zIndex: 1,
            }}
          >
            TOA Apparel
          </div>

          <p
            className="sm-card-desc"
            style={{
              fontSize: 13,
              color: "#8b9080",
              lineHeight: 1.7,
              marginBottom: 18,
              position: "relative",
              zIndex: 1,
              fontFamily: "'Cinzel',serif",
              letterSpacing: 0.3,
            }}
          >
            Official clothing from TOA Apparel, designed for the community and made to be worn beyond it.
          </p>

          <div
            className="sm-tags"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 6,
              justifyContent: "center",
              marginBottom: 36,
              position: "relative",
              zIndex: 1,
            }}
          >
            {[
              "Hoodies",
              "T-Shirts",
              "Accessories",
              "Limited Drops",
            ].map((t) => (
              <span
                className="sm-tag"
                key={t}
                style={{
                  fontSize: 10,
                  padding: "2px 9px",
                  borderRadius: 20,
                  background: "rgba(201,168,76,.1)",
                  border: "1px solid rgba(201,168,76,.2)",
                  color: "#c9a84c",
                  fontFamily: "'Cinzel',serif",
                }}
              >
                {t}
              </span>
            ))}
          </div>

          <span
            className="sm-cta"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 7,
              padding: "10px 22px",
              borderRadius: 7,
              background: "rgba(201,168,76,.12)",
              border: "1px solid rgba(201,168,76,.35)",
              color: "#c9a84c",
              fontFamily: "'Cinzel',serif",
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: 1,
              textTransform: "uppercase",
              position: "relative",
              zIndex: 1,
            }}
          >
            Browse Apparel
            <ArrowRight style={{ width: 13, height: 13 }} />
          </span>
        </div>

        {/* Minecraft Store */}
        <div
          className="sm-card"
          style={{
            padding: "32px 24px",
            textAlign: "center",
            cursor: "pointer",
            background: "linear-gradient(145deg,#071a09,#0d2c0e)",
            border: "1px solid rgba(74,222,128,.22)",
            position: "relative",
            overflow: "hidden",
            transition: ".25s",
          }}
          onClick={() => onOpenMcStore("ranks")}
          onMouseOver={(e) => {
            e.currentTarget.style.borderColor =
              "rgba(74,222,128,.45)";
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow =
              "0 16px 50px rgba(74,222,128,.12)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.borderColor =
              "rgba(74,222,128,.22)";
            e.currentTarget.style.transform = "";
            e.currentTarget.style.boxShadow = "";
          }}
        >
          <div
            className="sm-card-icon"
            style={{
              width: 72,
              height: 72,
              borderRadius: 16,
              background:
                "linear-gradient(135deg,rgba(74,222,128,.2),rgba(74,222,128,.06))",
              border: "1px solid rgba(74,222,128,.28)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
              position: "relative",
              zIndex: 1,
            }}
          >
            <Pickaxe
              style={{
                width: 34,
                height: 34,
                color: "#4ade80",
              }}
            />
          </div>

          <div
            className="sm-card-title"
            style={{
              fontFamily: "'Cinzel Decorative',serif",
              fontSize: 20,
              color: "#4ade80",
              marginBottom: 10,
              position: "relative",
              zIndex: 1,
            }}
          >
            Minecraft Store
          </div>

          <p
            className="sm-card-desc"
            style={{
              fontSize: 13,
              color: "#8b9080",
              lineHeight: 1.7,
              marginBottom: 18,
              position: "relative",
              zIndex: 1,
              fontFamily: "'Cinzel',serif",
              letterSpacing: 0.3,
            }}
          >
            Ranks, TOA Coins, crates and exclusive in-game perks. Dominate the
            SMP in style.
          </p>

          <div
            className="sm-tags"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 6,
              justifyContent: "center",
              marginBottom: 16,
              position: "relative",
              zIndex: 1,
            }}
          >
            {["Ranks", "TOA Coins", "Crates", "Perks"].map((t) => (
              <span
                className="sm-tag"
                key={t}
                style={{
                  fontSize: 10,
                  padding: "2px 9px",
                  borderRadius: 20,
                  background: "rgba(74,222,128,.1)",
                  border: "1px solid rgba(74,222,128,.2)",
                  color: "#86efac",
                  fontFamily: "'Cinzel',serif",
                }}
              >
                {t}
              </span>
            ))}
          </div>

          <div
            className="sm-btns"
            style={{
              display: "flex",
              gap: 8,
              justifyContent: "center",
              marginBottom: 16,
              position: "relative",
              zIndex: 1,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => onOpenMcStore("ranks")}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 5,
                fontSize: 10,
                padding: "5px 12px",
                borderRadius: 6,
                background: "rgba(123,94,167,.15)",
                border: "1px solid rgba(123,94,167,.35)",
                color: "#c9a84c",
                fontFamily: "'Cinzel',serif",
                cursor: "pointer",
              }}
            >
              <Crown style={{ width: 10, height: 10 }} />
              Ranks
            </button>

            <button
              onClick={() => onOpenMcStore("coins")}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 5,
                fontSize: 10,
                padding: "5px 12px",
                borderRadius: 6,
                background: "rgba(167,139,250,.12)",
                border: "1px solid rgba(167,139,250,.3)",
                color: "#a78bfa",
                fontFamily: "'Cinzel',serif",
                cursor: "pointer",
              }}
            >
              <img
                src="/toa_coin_32.png"
                alt="coin"
                style={{
                  width: 11,
                  height: 11,
                  imageRendering: "pixelated",
                }}
              />
              Coins
            </button>
          </div>

          <span
            className="sm-cta"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 7,
              padding: "10px 22px",
              borderRadius: 7,
              background: "rgba(74,222,128,.12)",
              border: "1px solid rgba(74,222,128,.35)",
              color: "#4ade80",
              fontFamily: "'Cinzel',serif",
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: 1,
              textTransform: "uppercase",
              position: "relative",
              zIndex: 1,
            }}
          >
            Browse Store
            <ArrowRight style={{ width: 13, height: 13 }} />
          </span>
        </div>
      </div>
    </OriginalModalShell>
  );
}